<div class="container">
@if (loading()) {
  <lib-frontend-spinner />
} 
@else {
  <div class="card">
    <div class="card-body text-center">
      @switch (type()) { 
        @case (1) { 
          @if (showAmazon()) {
            <h1 class="card-title">Bezahlen mit Amazon</h1>
            <lib-frontend-amazonpay-starter [data]="data()" />
          }
          @else if(showGoogePayOverPaypal()) {
            <h1 class="card-title">Bezahlen mit Google Pay</h1>
            <lib-frontend-googlepay [data]="data()" />
          }
          @else if(showApplePayOverPaypal()) {
            <h1 class="card-title">Bezahlen mit Apple Pay</h1>
            <lib-frontend-applepay [data]="data()" />
          }
          @else {
            <h1 class="card-title">Sie werden jetzt zu {{choosedPaymentprovider().name}} weitergeleitet.</h1>
            <p>Sollte es nicht funktionieren, dann klicken Sie <a [href]="link()">hier</a>.</p>
          } 
        }
        @case (2) {
          <h1 class="card-title">{{choosedPaymentprovider().response_header ?? 'Zahlungsweise per Überweisung wurde registriert'}} </h1>
          <p>{{choosedPaymentprovider().response_text ?? 'Sie erhalten dazu weitere Informationen per Email.'}}</p>
        }
      }
    </div>
  </div>
}
</div>
